module.exports = __webpack_public_path__ + "static/img/faqs4.b3e5ccb.png";